module.exports = (__parcel__import__("./" + "module.1a76ec57.js")).then(() => parcelRequire('2vSYt'));